import styled from 'styled-components';

export const DivContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 230px);
    & .title-container {
        margin-left: 0.8rem;
    }
`

export const DivDiffResult = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    max-width: 100%;
    max-height: 100%;
    overflow-y: auto;
    flex-grow: 1;
    & .detail-key {
        font-weight: 500;
        margin-right: 0.2rem;
    };
    & .detail-value {
        color: ${(props) => props.theme.text2};
    };
    & .detail-div {
        display: flex;
        background-color: ${(props) => props.theme.surface};
    };
    & .detail-div-array > .highlight.detail-div-master > .detail-div {
        background-color: ${(props) => props.theme.accentSoft};
    };
    & .highlight.detail-div-master > * > .detail-div-array > span.detail-value:not([class*=" "]) {
        background-color: ${(props) => props.theme.surface};
    };
    & .detail-div-array {
        display: flex;
        flex-direction: column;
    };
    & .detail-div-master {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
    };
    & .detail-link {
        background: none;
        border: none;
        text-decoration: underline;
        cursor: pointer;
        font-size: 1rem;
        color: ${(props) => props.theme.text2};
        width: fit-content;
        padding: 1px 0px;
    };
    & .detail-link:hover {
        color: ${(props) => props.theme.text};
    };
    & .highlight {
        background-color: ${(props) => props.theme.accentSoft};
    };
    & .nested-object > .detail-div-master, .detail-div-array > .detail-div-master {
        gap: 0rem
    };
    & p {
        margin: 0;
    };
    & .active {
        transform: scaleY(1);
        transform-origin: top;
        height: auto;
        transition: transform 0.2s ease;
    };
    & .inactive {
        transform: scaleY(0);
        height: 0;
    };
`